export function useFieldPermissions() {
    const canViewerRead = (field, isAdmin = false) =>
        field.viewer_permissions?.read ?? (isAdmin || field.permissions.read);

    const canViewerWrite = (field, isAdmin = false) =>
        field.viewer_permissions?.write ?? (isAdmin || field.permissions.write);

    return { canViewerRead, canViewerWrite };
}
